import { SingleSelect } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export const textDecorationOptions = {
	none: 'None',
	underline: 'Underline',
	'line-through': 'Line through',
	overline: 'Overline',
};


export function TextDecoration()
{
	return (
		<StyleFieldsRow>
			<TextDecorationFields />
		</StyleFieldsRow>
	);
}


/* The decoration on its own, for a caller that names the location itself - see ruleProperties(). */
export function TextDecorationFields()
{
	return (
		<LabelOnLeftWrap label='' narrow={true}>
			<SingleSelect field='decoration' options={textDecorationOptions} />
		</LabelOnLeftWrap>
	);
}
